import React, { useState } from 'react';
import { Typography, Box, useMediaQuery, useTheme, FormControl, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Select } from '../../../../../Components';
import { SelectOption } from '../../../../../Components/Form/Form.types';
import { StepButtonBar } from '../EditLegalListWizard/StepButtonBar';
import { StepProps } from './types';
import { useStyles } from '../../../../../Components/Field/Field.styles';
import UpdateConnectionInfo from './UpdateConnectionInfo';
interface Step5LawConnectionTypeSelectProps extends StepProps {
  selectedType?: SelectOption | null;
  onTypeSelect: (type: SelectOption) => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step5LawConnectionTypeSelect = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedType,
  onTypeSelect,
  currentStepName,
    updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step5LawConnectionTypeSelectProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [localSelected, setLocalSelected] = useState<SelectOption | null>(selectedType || null);
const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);
  
const classes = useStyles();
  const handleNext = () => {
    if (localSelected) {
      onTypeSelect(localSelected);
      onNext();
    }
  };
 const typeOptions = [
    { label: formatMessage({ id: 'law-portal.manage.edit-law.connectedProcesses' }), value: 'process' },
    { label: formatMessage({ id: 'law-portal.manage.edit-law.connectedAspects' }), value: 'aspect' },
    { label: formatMessage({ id: 'law-portal.manage.edit-law.connectedTags' }), value: 'tag' },
    { label: formatMessage({ id: 'law-portal.manage.edit-law.editCompanyUnit' }), value: 'editCompanyUnit' },
  ]
  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Box style={{ maxWidth: '100%', width: '100%', minWidth: '320px' }}>

                  <FormControl className={classes.formControl} style={{ width: '100%' }}>
                    <Select
                      selectProps={{
                        options: typeOptions,
                        value: localSelected,
                        onChange: (val: any) => setLocalSelected(val),
                        placeholder: formatMessage({ id: 'law-portal.manage.update-laws.type.placeholder' }),
                        isClearable: true,
                      }}
                    />
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
        updateConnectionInfo={updateConnectionInfo}
        currentStepName={currentStepName}
        onUpdate={setUpdateConnectionInfo}
      />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelected}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step5LawConnectionTypeSelect;
